<ion-header class="header --w-back-button --underline">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-list class="breadcrumb">
        <ion-item
          *ngFor="let breadcrumb of breadcrumbs"
          class="breadcrumb__item"
          detail="false"
          routerDirection="back"
          [routerLink]="[breadcrumb.link]"
        >
          <span [innerHTML]="breadcrumb.name"></span> <span class="breadcrumb__item__dash">/</span>
        </ion-item>
      </ion-list>
      <ion-back-button [defaultHref]="defaultHref" text="" icon="arrow-back-outline"></ion-back-button>
    </ion-buttons>
    <ion-title [innerHTML]="(stepId$ | async) ? (step$ | async)?.name : ('ADMIN_LEARNING_MODULES.ADD_STEP' | translate)"></ion-title>
    <ion-buttons slot="end">
      <ion-menu-button class="header__burger" icon="menu-outline" autoHide="false"></ion-menu-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="step-form">
  <div class="white-wrapper">
    <span
      class="step-form__title"
      [innerHTML]="(step$ | async) ? (step$ | async)?.name : ('ADMIN_LEARNING_MODULES.ADD_STEP' | translate)"
    ></span>
    <form class="step-form__form" [formGroup]="form">
      <ion-item class="step-form__form__item">
        <ion-label
          class="step-form__form__item__label"
          position="stacked"
          [innerHTML]="'ADMIN_LEARNING_MODULES.NAME_LABEL' | translate"
        ></ion-label>
        <ion-input class="step-form__form__item__input" type="text" formControlName="name"></ion-input>
      </ion-item>

      <ion-item class="step-form__form__item">
        <ion-label
          class="step-form__form__item__label"
          position="stacked"
          [innerHTML]="'ADMIN_LEARNING_MODULES.EMOJI_LABEL' | translate"
        ></ion-label>
        <ion-input class="step-form__form__item__input" type="text" formControlName="emoji" (click)="showPicker()"></ion-input>
      </ion-item>

      <ion-item class="step-form__form__item">
        <ion-label
          class="step-form__form__item__label"
          position="stacked"
          [innerHTML]="'ADMIN_LEARNING_MODULES.ORDER_LABEL' | translate"
        ></ion-label>
        <ion-input class="step-form__form__item__input" type="number" step="1" formControlName="order"></ion-input>
      </ion-item>

      <ion-item class="step-form__form__item">
        <ion-label
          class="step-form__form__item__label"
          position="stacked"
          [innerHTML]="'ADMIN_LEARNING_MODULES.MARK_AS_VIEWED_LABEL' | translate"
        ></ion-label>
        <ion-input class="step-form__form__item__input" type="number" step="1" formControlName="markAsViewedAt"></ion-input>
      </ion-item>

      <ion-item class="step-form__form__item">
        <ion-label
          class="step-form__form__item__label"
          position="stacked"
          [innerHTML]="'ADMIN_LEARNING_MODULES.CONTENT_LABEL' | translate"
        ></ion-label>
        <ckeditor
          ngDefaultControl
          class="step-form__form__item__textarea"
          formControlName="content"
          [editor]="editor"
          [config]="editorConfig"
          (change)="ckeditorChanged($event)"
        ></ckeditor>
      </ion-item>

      <ion-item class="step-form__form__item">
        <ion-label
          class="step-form__form__item__label"
          position="stacked"
          [innerHTML]="'ADMIN_LEARNING_MODULES.ATTACHMENTS_LABEL' | translate"
        ></ion-label>
        <ion-button class="step-form__form__buttons__button" (click)="filesInput.click()">
          <ion-icon name="document-outline"></ion-icon>
        </ion-button>
        <ion-list class="step-form__form__item__attachments">
          <ion-item *ngFor="let file of attachments" class="step-form__form__item__attachments__file no-item" lines="none">
            <ion-icon slot="start" name="document-outline"></ion-icon>
            <ion-text [innerHTML]="file.name"></ion-text>
            <ion-icon slot="end" color="danger" name="close-outline" (click)="removeAttachment(file)"></ion-icon>
          </ion-item>
          <ion-item *ngFor="let file of (step$ | async)?.attachments" class="step-form__form__item__attachments__file no-item" lines="none">
            <ion-icon slot="start" name="document-outline"></ion-icon>
            <ion-text [innerHTML]="file.name"></ion-text>
            <ion-icon slot="end" color="danger" name="close-outline" (click)="removeAttachment(file)"></ion-icon>
          </ion-item>
        </ion-list>
      </ion-item>

      <div class="step-form__form__buttons">
        <div *ngIf="(step$ | async)?.imageUrl || image?.base64String" class="step-form__form__buttons__remove" (click)="removeImage()">
          x
        </div>
        <ion-button class="step-form__form__buttons__button" (click)="loadImage()">
          <ion-img *ngIf="image?.base64String; else stepImage" src="data:image/{{image.format}};base64,{{image.base64String}}"></ion-img>
          <ng-template #stepImage>
            <ion-img *ngIf="(step$ | async)?.imageUrl; let source; else cameraIcon" [src]="source"></ion-img>
          </ng-template>
          <ng-template #cameraIcon><ion-icon name="camera"></ion-icon></ng-template>
        </ion-button>

        <div *ngIf="(step$ | async)?.videoUrl || video" class="step-form__form__buttons__remove" (click)="removeVideo()">x</div>
        <ion-button class="step-form__form__buttons__button" (click)="videoInput.click()">
          <video *ngIf="video; else stepVideo" controls><source [src]="video | safeUrl" /></video>
          <ng-template #stepVideo>
            <video *ngIf="(step$ | async)?.videoUrl; let source; else videoIcon"><source [src]="source" /></video>
          </ng-template>
          <ng-template #videoIcon><ion-icon name="videocam"></ion-icon></ng-template>
        </ion-button>
      </div>

      <div class="step-form__form__footer">
        <ion-button class="button --tertiary" [innerHTML]="'BUTTONS.CANCEL' | translate | lowercase" (click)="cancel()"></ion-button>
        <ion-button class="button --primary" [disabled]="form.invalid || form.pristine || (loading$ | async)" (click)="save()">
          <ion-spinner *ngIf="loading$ | async; else text"></ion-spinner>
          <ng-template #text>
            <span [innerHTML]="'BUTTONS.SAVE' | translate"></span>
          </ng-template>
        </ion-button>
      </div>
    </form>
  </div>

  <input #videoInput hidden type="file" accept="video/*" (change)="loadVideo($event)" />
  <input #filesInput hidden multiple type="file" accept="*.pdf" (change)="loadAttachments($event)" />
</ion-content>
